module.exports = __webpack_public_path__ + "static/media/10.4dbe8048.png";